import moment from "moment";
window.moment = moment;

export const compareDates = (start_date, end_date) => {
    start_date = moment(start_date)
    end_date = moment(end_date)
    return end_date.diff(start_date);
}

export const convertDateFormat = (date, date_format) => {
  date = date || null;
  if(date == null){
    return date;
  }
  date_format = date_format || 'YYYY-MM-DD'
  try {
    date = moment(date).format(date_format)
  } catch (err) {
    console.log('MOMENT ERROR:', err)
  }
  return date
}

export const jsonToQueryString = (json) => {
  return Object.keys(json).map(function(key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  }).join('&');
}